<template>
  <div id="app">
    <j-header></j-header>
    <transition enterActiveClass="animated fadeIn" leaveActiveClass="animated fadeOut"
                mode="out-in">
      <router-view></router-view>
    </transition>
    <sitemap class="sitemap"></sitemap>
    <m-sitemap class="msitemap"></m-sitemap>
    <j-footer></j-footer>
  </div>
</template>

<script>
import JHeader from './components/Header.vue'
import Sitemap from './components/Sitemap.vue'
import MSitemap from './components/common/MSitemap.vue'
import JFooter from './components/Footer.vue'
import { catalog, newsList } from './service/api'
import { mapState } from 'vuex'
export default {
  name: 'App',
  components: {
    JHeader, JFooter, Sitemap, MSitemap
  },
  methods: {
    getCatalog () {
      catalog()
        .then(({ data, err }) => {
          if (data.status === 200) {
            console.log(data.data)
            this.$store.commit('setCatalog', data.data)
            sessionStorage.setItem('kana_catalog', JSON.stringify(data.data))
          } else {
            console.log(err)
          }

        })
    },
    getNewsList() {
      newsList()
        .then(({ data, err }) => {
          if (data.status === 200) {
            this.$store.commit('setNews', data.data)
            sessionStorage.setItem('kana_news', JSON.stringify(data.data))
          } else {
            console.log(err)
          }
        })
    }
  },
  created () {
    this.getCatalog()
    this.getNewsList()
  }
}
</script>

<style type="text/scss" lang="scss" rel="stylesheet/scss">
  @import './styles/declaration';
  @import './styles/reset';
  #app {
    font-family: 'Noto Sans TC', sans-serif, '黑体', PingFangSC, helvetica neue,
    hiragino sans gb, arial, microsoft yahei ui, microsoft yahei;
    /*font-family:'微软雅黑', '黑体', 'Microsoft YaHei UI', 'Avenir', Helvetica, Arial, sans-serif;*/
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #333;
    height: inherit;
    min-width: $min-width;
    margin: 0 auto;
    padding: 0;
  }
  #app > div.animated,
  #app > div > div.animated {
    animation-duration: 0.5s;
  }
  .placeholder {
    height: 130px;
  }
  .placeholder.header-fixed {
    height: 105px;
  }
  .msitemap{
    display: none;
  }
  @media screen and (min-width: 1320px) {
    #app {
      height: auto;
      position: relative;
    }
  }
  // @media screen and (max-width: 1319px) {
  //   #app{
  //     min-width: 0;
  //     width: 100%;
  //     height: 100%;
  //     overflow: scroll;
  //   }
  // }
  @media screen and (max-width: 767px) {
    #app {
      min-width: 0;
    }
    .placeholder {
      display: none;
      height: 0;
    }
    .sitemap{
      display: none;
    }
    .msitemap{
      display: block;
    }
  }
</style>
<style type="text/scss" rel="stylesheet/scss" lang="scss" scoped>
  @media screen and (max-width: 767px) {
    .sp-layout {
      padding: 0 15px;
      display: flex;
      margin-top: 10px;
      justify-content: space-between;
      .box-element {
        display: inline-block;
        width: 48%;
        padding: 20px 0;
        .j-btn {
          background-color: #999;
          width: 100%;
          text-align: center;
        }
        a {
          padding: 10px 5px 12px;
          font-size: 0.9rem;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue